var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4817 8.55279C15.4817 10.7773 13.6783 12.5806 11.4538 12.5806C9.22928 12.5806 7.42595 10.7773 7.42595 8.55279C7.42595 6.32826 9.22928 4.52493 11.4538 4.52493C13.6783 4.52493 15.4817 6.32826 15.4817 8.55279ZM13.4677 8.55279C13.4677 9.66505 12.5661 10.5667 11.4538 10.5667C10.3415 10.5667 9.43988 9.66505 9.43988 8.55279C9.43988 7.44053 10.3415 6.53886 11.4538 6.53886C12.5661 6.53886 13.4677 7.44053 13.4677 8.55279Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4538 0.49707C5.33637 0.49707 0.377197 5.45624 0.377197 11.5737C0.377197 17.6911 5.33637 22.6503 11.4538 22.6503C17.5713 22.6503 22.5304 17.6911 22.5304 11.5737C22.5304 5.45624 17.5713 0.49707 11.4538 0.49707ZM2.39113 11.5737C2.39113 13.6784 3.10864 15.6156 4.3124 17.154C5.96832 14.9862 8.5802 13.5876 11.5187 13.5876C14.4192 13.5876 17.0013 14.9501 18.6602 17.07C19.8247 15.5454 20.5165 13.6403 20.5165 11.5737C20.5165 6.5685 16.459 2.511 11.4538 2.511C6.44863 2.511 2.39113 6.5685 2.39113 11.5737ZM11.4538 20.6364C9.2886 20.6364 7.30074 19.8771 5.74198 18.6102C7.01664 16.791 9.12878 15.6015 11.5187 15.6015C13.879 15.6015 15.9684 16.7616 17.2477 18.5427C15.6769 19.8501 13.6572 20.6364 11.4538 20.6364Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4408fb70ce0250ea54bdf4e188b7b5b1.svg";
export { ForwardRef as ReactComponent };